<template>
    <div class="list-count-container">
        <p>Exibindo {{amount}} itens</p>
    </div>
</template>

<script>
export default {
    name: 'ListCountCmp',    
    props: {
        amount: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style lang="scss" scoped>
.list-count-container {
    margin-top: -20px;
    padding-top: 15px;
    color: #777;
    font-size: .9em;
    letter-spacing: 1px;
}
</style>